import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import WhoImage from '../assets/who-image.jpg';
import '../styles/who-we-are.css';

function WhoWeAre() {
  return (
    <motion.div 
      className='who-we-are-container'
      initial={{ opacity: 0, y: 50 }} // Start slightly below and fade in
      animate={{ opacity: 1, y: 0 }} // Animate into place
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      {/* Text Section Animation */}
      <motion.div
        className="who-text"
        initial={{ opacity: 0, x: -50 }} // Slide in from left
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <h2>Who We Are?</h2>
        <p>
          <span>NEXTCASTLE ENERGY LIMITED</span> is an Oil Services company incorporated in 2006 with 
          its corporate office and fabrication yard in Port Harcourt, Nigeria. The philosophy of the 
          company is to provide the client with complete, quality oilfield services at competitive prices.
        </p>
        <p>
          Toward this goal, the company emphasizes the use of experienced, well-trained indigenes 
          with minimal EXPATRIATE involvement. Nextcastle has been in continuous compliance with 
          recent Nigerian Content legislation since inception. The Managing Director is a Nigerian.
        </p>
      </motion.div>

      {/* Image Section Animation */}
      <motion.div
        className="who-image"
        initial={{ opacity: 0, x: 50 }} // Slide in from right
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <img src={WhoImage} alt="oil-and-gas-image" />
      </motion.div>
    </motion.div>
  );
}

export default WhoWeAre;
